module.exports = __webpack_public_path__ + "img/industry-banner-crm-03.b05d97c7.png";